import React, { Component } from 'react'
import FormViewer from '../../FormViewer'
import ButtonAnimated from '../../buttons/ButtonAnimated'
import { getObject, translate } from '../../../utils/useful'
import HttpServices from '../../../utils/Http.services'
import store from '../../../stores/storeConfig'
import { addNotif } from '../../../stores/actionsList'

export default class Stripe extends Component {
    authWindowRef = null
    state = {
        fields: [
            { key: 'email', type: 'TextInput', col: '6', information: { label: '{{lang}}email', placeholder: '', required: true } },
            // { key: 'clientId', type: 'TextInput', col: '6', information: { label: '{{lang}}Client ID', placeholder: '', required: true } },
        ]
    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }


    componentDidMount() {
        // window.addEventListener('message', this.handleMessage);
    }
    componentDidUpdate = () => {

    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }
    handleMessage = (event) => {
        if (event.source === this.authWindowRef) {
            const { type, data } = event.data;

            if (type === 'login') {
                // Handle the retrieved data after login
                // this.setState({ userData: data });
                console.log('Received login data:', data);

                // Optionally, close the authentication window
                // this.authWindowRef.close();
            }
        }
    }

    submitForm = () => {
        let data = this.form.getForm()
        if (data) {
            HttpServices.request('createStripeConnectedAccount', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                this.props.changeInputValue(fetchResult.account)
                window.open(fetchResult.info.url, '_blank', 'toolbar=no,height=450,width=450,directories=no')

            })
        }
        // this.authWindowRef = window.open(`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_PfrRMegdIxK7R7izKYUwfls398knZKjx&scope=read_write&redirect_uri=https://platform.yonnect.com/yonnect/api-p/stripeauthorized`, '_blank', 'toolbar=no,height=450,width=450,directories=no')
        // let data = this.form.getForm()
        // let api = getObject(data, 'accessKey')
        // HttpServices.request('checkEasyPostApiKey', { accessKey: api }, (fetchResult, fetchError) => {
        //     if (fetchError) {
        //         store.dispatch(addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message }))
        //         return
        //     }
        //     let thirdparty = this.form.getForm() ?? {}
        //     this.props.changeInputValue(thirdparty)
        //     store.dispatch(addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' }))

        // })
    }

    render() {
        return (
            <div className="w-100 h-100  pt-2 pb-4"  >
                <div className='flexc px-3 pb-3' style={{ borderBottom: '1px solid #eee' }}>
                    <div className='flexcc'>
                        <img src='/assets/thirdparties/stripe.png' height={40} />
                    </div>
                    <div className='mld-4'>
                        <p className='weight-600 text-normal main-c2'>{translate("Connect to your Stripe account")}</p>
                        <a className='text-link text-small weight-500 mt-1' href='https://www.Stripe.com/' target='_blank' rel="noreferrer">{translate("Don't have an account? Click here")}</a>
                    </div>
                </div>

                <div className='mt-3 px-3'>
                    <div className='text-small br-8 px-3 py-2' style={{ border: '2px dashed #675bf750' }}>
                        <p className='weight-700 text-normal mb-2' style={{ color: '#675bf7' }}>Note:</p>
                        <div className='flexc pb-2 '>
                            <div className='flexcc mr-2' style={{width:'5px', height:'5px', borderRadius:100, backgroundColor:'#675bf7'}}/>
                            <p style={{}} className='text-small weight-500'>Log in to your <span className='weight-700' style={{color:'#675bf7'}}>Stripe</span> account.</p>
                        </div>
                        <div className='flexc pb-2 '>
                            <div className='flexcc mr-2' style={{width:'5px', height:'5px', borderRadius:100, backgroundColor:'#675bf7'}}/>
                            <p className='text-small weight-500'>Add your email and submit it.</p>
                        </div>
                        <div className='flexc pb-2 '>
                            <div className='flexcc mr-2' style={{width:'5px', height:'5px', borderRadius:100, backgroundColor:'#675bf7'}}/>
                            <p className='text-small weight-500'>Complete the remaining information in the Stripe portal to finalize the setup.</p>
                        </div>
                        <a className='text-link text-small' href='https://www.easypost.com/account/settings?tab=api-keys' target='_blank' rel="noreferrer">{translate("Find your API key here")}</a>
                    </div>
                </div>


                <div className='mt-4'>
                    <FormViewer ref={el => this.form = el} headers={this.state.fields} formClass="bordered-form" inputClass={'bordered-input'} />
                </div>


                <div className='mt-0 px-3'>
                    <ButtonAnimated
                        icon={'/assets/icons/angle-right-white2.svg'}
                        bg={'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))'}
                        textColor={'#fff'}
                        title={'{{lang}}Connect Stripe'}
                        invert={false}
                        onClick={() => this.submitForm()}
                    />
                </div>
            </div>
        )
    }
}
